<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="#" title="Home">Certificações internacionais</a></li>
                            <li>Política de preços</li>
                        </ul>
                    </section>
                    <section class="col-sm-6">
                        <button class="btn-large-40 btn-success uppercase pull-right btn-header" @click="openCreate()">
                            Criar
                        </button>
                    </section>
                </div>
            </div>
            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Filtros</b></h2>
                    </div>
                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="nome">Política comercial</label>
                                    <input type="text" class="form-control" name="politicaComercial" placeholder="Nome da Política Comercial" maxlength="50" v-model="filter.Nome" />
                                </div>
                                <div class="form-group col-md-3">
                                    <label>Situação</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" value="undefined" v-model="filter.ativo" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" value="true" v-model="filter.ativo" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Ativo</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" value="false" v-model="filter.ativo" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Inativo</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group col-md-3">
                                    <label for="sessao">Sessão</label>
                                    <input type="text" class="form-control" name="sessao" v-model="filter.certificacoesPoliticaPrecoId" maxlength="9" placeholder="Id da Sessão" />
                                </div>
                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>
                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>#<i class="fa fa-sort"></i></th>
                                    <th>Nome da Política<i class="fa fa-sort"></i></th>
                                    <th class="text-right">Situação<i class="fa fa-sort"></i></th>
                                    <th class="text-sm-center">Sessões Vinculadas<i class="fa fa-sort"></i></th>
                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.certificacoesPoliticaPrecoId}}</td>
                                    <td>{{ item.nome}}</td>
                                    <td class="text-right"><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.ativo, 'badge-danger': !item.ativo }">{{item.ativo ? 'Ativo' : 'Inativo'}}</span></td>
                                    <td class="text-center">{{ item.quantidadeSessao}}</td>
                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-primary" v-b-tooltip title="Editar" @click="openEdit({ certificacoesPoliticaPrecoId: item.certificacoesPoliticaPrecoId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-success" v-b-tooltip title="Vincular Sessão" @click="openVincularSessao({ certificacoesPoliticaPrecoId: item.certificacoesPoliticaPrecoId })">
                                            <i class="fa fa-plus"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-warning" v-b-tooltip title="Log de Alterações" @click="openLog({ certificacoesPoliticaPrecoId: item.certificacoesPoliticaPrecoId })">
                                            <i class="fa fa-history"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" size="xl" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Nova Política Comercial">
            <form-create v-if="dialogCreate" style="max-height: 400px; overflow-x: hidden; overflow-y: auto; " @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEdit" size="xl" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="certificacoesPoliticaPrecoId" style="max-height: 400px; overflow-x: hidden; overflow-y: auto; " @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogLog" size="lg" :hide-footer="true" title="Log de Alterações">
            <form-log v-if="dialogLog" :id="certificacoesPoliticaPrecoId" style="max-height: 400px; overflow-x: hidden; overflow-y: auto;" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogVincularSessao" size="lg" :hide-footer="true" title="Vincular Sessão">
            <form-vincularsessao v-if="dialogVincularSessao" :id="certificacoesPoliticaPrecoId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>
    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'
    import formVincular from './form-vincularsessao'
    import formLog from './form-log'

    export default {
        name: 'certificacoespoliticapreco',
        mixins: [base],
        components: { formCreate, formEdit, 'form-vincularsessao': formVincular, 'form-log': formLog },
        data() {
            return {

                resources: {
                    filter: 'certificacoespoliticapreco',
                },

                dialogCreate: false,
                dialogEdit: false,
                dialogVincularSessao: false,
                dialogLog: false,
                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openVincularSessao: function (model) {
                this.certificacoesPoliticaPrecoId = model.certificacoesPoliticaPrecoId;
                this.dialogVincularSessao = true;
            },
            openEdit: function (model) {
                this.certificacoesPoliticaPrecoId = model.certificacoesPoliticaPrecoId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            openLog: function (model) {
                this.certificacoesPoliticaPrecoId = model.certificacoesPoliticaPrecoId;
                this.dialogLog = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogVincularSessao = false;
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                new Api('certificacoespoliticapreco/consultaPoliticaPreco').get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },
        mounted() {
            this.executeFilter();
        }

    };
</script>